var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 300,
    height: 170.206,
    viewBox: "0 0 400 252.206",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.aa,.ab,.ac,.b,.i,.m,.u,.v,.w,.x,.z{fill:none;}.b{stroke:#ded8d5;stroke-width:1.968px;}.ab,.b,.i,.w{stroke-miterlimit:10;}.c{fill:#ffb1a5;}.d{fill:#ead254;}.e{fill:#00857b;}.f,.g{fill:#0157ff;}.f{opacity:0.3;}.h{fill:#70b603;}.ab,.ac,.i{stroke:#fff;}.i{stroke-width:1.18px;}.j{fill:#f59a23;}.k{clip-path:url(#a);}.l{fill:#8e716c;}.aa,.m,.u,.v,.x,.z{stroke:#282828;}.aa,.ac,.m,.u,.v,.x,.z{stroke-linecap:round;stroke-linejoin:round;}.m{stroke-width:1.233px;}.n{fill:#f3978e;}.o{fill:#372f5f;}.p{fill:#261b43;}.q{fill:#e6e6e6;}.r{fill:#fff;}.s{fill:#004bb7;}.t{fill:#282828;}.u{stroke-width:0.993px;}.v{stroke-width:1.232px;}.w{stroke:#c98bd2;stroke-width:1.342px;}.x{stroke-width:1.23px;}.y{fill:#005683;}.z{stroke-width:1.397px;}.aa{stroke-width:1.532px;}.ab{stroke-width:1.951px;}.ac{stroke-width:2px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 288.735,
    height: 209.151
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-61.887 -35.304)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(102.179 92.287)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 313.942,
    transform: "translate(0 20.58)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 313.942,
    height: 194.239,
    rx: 6.521
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.946 7.628)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M155.495,140.948a2.872,2.872,0,1,1-2.872-2.871A2.872,2.872,0,0,1,155.495,140.948Z",
    transform: "translate(-149.751 -138.077)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M173.247,140.948a2.871,2.871,0,1,1-2.871-2.871A2.872,2.872,0,0,1,173.247,140.948Z",
    transform: "translate(-156.343 -138.077)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M191,140.948a2.872,2.872,0,1,1-2.872-2.871A2.872,2.872,0,0,1,191,140.948Z",
    transform: "translate(-162.935 -138.077)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M128.019,94.615H64.272a2.385,2.385,0,0,1-2.385-2.385h0a2.385,2.385,0,0,1,2.385-2.385h63.747a2.384,2.384,0,0,1,2.385,2.385h0A2.384,2.384,0,0,1,128.019,94.615Z",
    transform: "translate(0 -20.253)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M674.667,342.3h-30.94a2.384,2.384,0,0,1-2.385-2.385h0a2.384,2.384,0,0,1,2.385-2.385h30.94a2.385,2.385,0,0,1,2.385,2.385h0A2.385,2.385,0,0,1,674.667,342.3Z",
    transform: "translate(-215.165 -112.223)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 7.378,
    height: 7.147,
    rx: 2.861,
    transform: "translate(432.253 250.514)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 7.378,
    height: 7.147,
    rx: 2.861,
    transform: "translate(73.877 267.034)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(304.007 52.75)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 66.707,
    height: 19.149,
    rx: 3.012
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.086 6.823)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "i",
    x2: 44.748
  }), /*#__PURE__*/React.createElement("line", {
    className: "i",
    x2: 18.226,
    transform: "translate(0 4.593)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M458.571,90.068v7.463l9.386-7.463Z",
    transform: "translate(-451.305 -73.085)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(178.419 35.304)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M6.46,0H33.416a6.46,6.46,0,0,1,6.46,6.46V31.275a6.46,6.46,0,0,1-6.46,6.46H8.521A8.521,8.521,0,0,1,0,29.214V6.46A6.46,6.46,0,0,1,6.46,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(131.097 76.867)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "k",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.888 2.538)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(161.738 7.99)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.521 125.458)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M486.327,320.777l-22.947-3.055.179,2.278-19.62,2.613s-12.646,31.729-1.5,101.509H458.4l5.744-70.757h2.04l5.563,70.757h15.96C498.851,354.342,486.327,320.777,486.327,320.777Z",
    transform: "translate(-437.845 -317.722)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "m",
    x2: 16.651,
    transform: "translate(19 35.644)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 63.847)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(50.933 19.139)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 8.961)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M527.732,267.513c-1.963-3.134-12.992-3.023-13.574-3.091-2.981-.35,1.912,23.374,8.114,44.112a6.963,6.963,0,0,0,9.384,4.427l.124-.052a6.972,6.972,0,0,0,4.134-7.715C532.964,289.546,530,271.136,527.732,267.513Z",
    transform: "translate(-513.261 -264.418)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M531.364,280.119l-14.08,5.464-1.32-6.681,14.58-3.637Z",
    transform: "translate(-514.264 -268.446)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M540.932,300.742s-6.67,8.958-6.352,8.546,5.231-14.477,5.231-14.477Z",
    transform: "translate(-521.173 -275.704)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.711)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M547.7,285.092l-19.119,24.772a7.03,7.03,0,0,0,1.738,10.192h0a7.03,7.03,0,0,0,10.009-2.547l15.914-29.362Z",
    transform: "translate(-527.117 -263.134)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.069 11.507)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M564.5,286.119a7.887,7.887,0,1,1,9.929-5.08A7.887,7.887,0,0,1,564.5,286.119Z",
    transform: "translate(-559.039 -269.306)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M572.906,273.035s2.158-2.241-1.67-3.812-8.563-1.21-11.585,6.128Z",
    transform: "translate(-559.266 -268.467)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.014)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M580.017,250.789l8.006,3.471a.826.826,0,0,1,.362,1.179l-10.532,19.671a1.007,1.007,0,0,1-1.25.48L568.6,272.12a.825.825,0,0,1-.362-1.179l10.532-19.671A1.007,1.007,0,0,1,580.017,250.789Z",
    transform: "translate(-567.356 -250.37)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M578.8,250.235l8.006,3.471a.826.826,0,0,1,.362,1.179l-10.532,19.671a1.007,1.007,0,0,1-1.25.48l-8.006-3.471a.825.825,0,0,1-.362-1.179l10.532-19.671A1.007,1.007,0,0,1,578.8,250.235Z",
    transform: "translate(-566.904 -250.164)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M579.322,253.461l7.034,3.05-8.583,16.032-7.034-3.05Z",
    transform: "translate(-568.328 -251.388)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M586.356,256.511l-15.617,12.983,8.583-16.032Z",
    transform: "translate(-568.328 -251.388)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M570.627,268.631a12.773,12.773,0,0,1,3.392,1.259,1.811,1.811,0,0,1,.875,2.01h0a1.8,1.8,0,0,1-1.52,1.35l-4.162.525s-2.171,3.743-5.009,4.163l2.6-6.572Z",
    transform: "translate(-540.888 -257.021)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M468.477,219.721c-.46,0,29.514,4.147,34.46,38.32l-15.553,2.383-3.136,25.8H440.858l-8.614-47.666a54.131,54.131,0,0,1,27.462-18.836Z",
    transform: "translate(-432.244 -219.721)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "m",
    y1: 14.921,
    x2: 1.35,
    transform: "translate(55.139 25.783)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.51)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M483.985,213.487v-11.87h-13.91v12.01a27.017,27.017,0,0,0-3.737,1.516l10.849,6.462,11.091-6.463A18.1,18.1,0,0,0,483.985,213.487Z",
    transform: "translate(-458.414 -149.151)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M472.077,201.763s2.5,6.633,9.167,6.06c6.13-.526,5.154-9.719,5.154-9.719Z",
    transform: "translate(-460.545 -147.847)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 36.763)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M459.2,184.97c-2.18,1.978-7.056-5.524-4.949-7.63s3.714,1.2,3.714,1.2l.941,2.239.709,3.033.169.795Z",
    transform: "translate(-453.733 -176.639)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.535 3.25)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M456.175,181.918s1.65-.742,3.116,1.65",
    transform: "translate(-456.175 -181.809)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.699 36.858)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M503.116,184.8c2,2.155,7.5-4.907,5.576-7.183s-3.8.88-3.8.88l-1.126,2.151-.964,2.962-.235.777Z",
    transform: "translate(-502.565 -176.791)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.643 3.218)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M508.423,182.077s-1.582-.88-3.245,1.381",
    transform: "translate(-505.178 -181.909)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.641 13.624)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M456.344,156.519c0,9.929,7.571,14.638,16.91,14.638s16.909-4.708,16.909-14.638-7.571-16.685-16.909-16.685S456.344,146.589,456.344,156.519Z",
    transform: "translate(-456.344 -139.834)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M459.994,158.557a67.883,67.883,0,0,0,1.721,15.09c.842,3.655,3.21,6.209,6.557,8.265l.61.375a11.508,11.508,0,0,0,11.714.13h0c3.626-2.114,6.166-4.9,6.947-8.824a99.233,99.233,0,0,0,1.577-15.035s1.352-15.388-14.355-15.089S459.994,158.557,459.994,158.557Z",
    transform: "translate(-456.054 -127.558)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.615 29.851)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M481.648,181.441v2.129a.97.97,0,0,0,.068.358.949.949,0,0,0,1.131.523l.977-.259",
    transform: "translate(-467.714 -171.511)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M473.065,167.676l-7.806,1.83s.355-1.987,3.548-2.709S473.065,167.676,473.065,167.676Z",
    transform: "translate(-461.628 -166.004)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M488.7,167.676l7.538,1.83s-.343-1.987-3.426-2.709S488.7,167.676,488.7,167.676Z",
    transform: "translate(-470.331 -166.004)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "t",
    cx: 1.317,
    cy: 1.313,
    rx: 1.317,
    ry: 1.313,
    transform: "translate(7.155 6.094)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M493.349,176.652a1.316,1.316,0,1,1-1.316-1.313A1.314,1.314,0,0,1,493.349,176.652Z",
    transform: "translate(-471.081 -169.245)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M475.052,190.172H485.2S480.7,195.645,475.052,190.172Z",
    transform: "translate(-465.264 -174.753)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "w",
    cx: 5.598,
    cy: 5.598,
    r: 5.598,
    transform: "translate(0 7.917) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "w",
    cx: 5.598,
    cy: 5.598,
    r: 5.598,
    transform: "translate(13.753 7.917) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M480.982,177.914a1.822,1.822,0,0,1,2.556,0",
    transform: "translate(-467.466 -169.997)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "w",
    x1: 1.763,
    y1: 0.045,
    transform: "translate(0.556 7.872)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "w",
    y1: 0.045,
    x2: 1.774,
    transform: "translate(27.268 7.872)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M503.025,165.493s-6.28-8.49-4.831-17.091a12.374,12.374,0,0,1,5.875,8.4C505.283,162.857,503.025,165.493,503.025,165.493Z",
    transform: "translate(-470.162 -129.391)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M459.467,165.727s7.3-9.643,5.847-18.244a14.364,14.364,0,0,0-6.274,8.978C457.826,162.515,459.467,165.727,459.467,165.727Z",
    transform: "translate(-455.537 -129.05)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M487.375,149.587s-8.064,8.828-30.126,7.317c0,0,3.379-12.954,14.07-14.334C471.319,142.57,483.665,141.1,487.375,149.587Z",
    transform: "translate(-455.039 -127.19)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "t",
    cx: 10.534,
    cy: 10.534,
    r: 10.534,
    transform: "translate(19.692 20.799) rotate(-80.831)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.796 19.755)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M271.146,319.655l-19.62-2.613.179-2.279-22.947,3.056s-12.525,33.564-1.379,103.345h15.96l5.563-70.757h2.04l5.744,70.757h15.96C283.792,351.383,271.146,319.655,271.146,319.655Z",
    transform: "translate(-207.516 -202.929)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.409)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M267.316,158.84a36.182,36.182,0,0,1-6.589-11.883c-1.939-5.49-8.292-3.258-8.292-3.258s-5.293-6.809-13.258-4.438-10.732,8.04-10.894,14.778-5.463,7.792-9.544,15.587c-7.2,13.762,4.926,25.353,27.007,22.138l.03-.214a23.17,23.17,0,0,0,8.092.756C280.4,190.73,277.838,171.218,267.316,158.84Z",
    transform: "translate(-216.662 -137.575)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(41.386 23.138)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M283.076,182.012c2.18,1.977,7.056-5.524,4.949-7.63s-3.714,1.2-3.714,1.2l-.941,2.239-.709,3.033-.169.794Z",
    transform: "translate(-282.492 -173.68)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.398 3.25)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M287.832,178.96s-1.65-.742-3.116,1.65",
    transform: "translate(-284.716 -178.851)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.208 23.233)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M238.876,181.841c-2,2.154-7.5-4.907-5.576-7.184s3.8.88,3.8.88l1.126,2.151.964,2.962.235.777Z",
    transform: "translate(-232.899 -173.832)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.64 3.218)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M235.508,179.119s1.582-.88,3.245,1.381",
    transform: "translate(-235.508 -178.951)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.976)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M269.529,153.56c0,9.929-7.57,14.638-16.909,14.638s-16.909-4.709-16.909-14.638,7.571-16.684,16.909-16.684S269.529,143.631,269.529,153.56Z",
    transform: "translate(-235.711 -136.876)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 13.91,
    height: 18.012,
    transform: "translate(21.864 38.841)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M248.211,196.872s3.872,7.728,8.635,8.934a6.7,6.7,0,0,0,3.859-.223c1.793-.636,4.067-3.308,4.453-6.266l.18-1.69S256.862,202.242,248.211,196.872Z",
    transform: "translate(-228.377 -159.154)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M268.628,155.6a67.872,67.872,0,0,1-1.721,15.089c-.842,3.655-3.21,6.209-6.557,8.266l-.61.374a11.508,11.508,0,0,1-11.714.13h0c-3.627-2.114-6.166-4.9-6.948-8.824A99.278,99.278,0,0,1,239.5,155.6s-1.352-15.388,14.355-15.089S268.628,155.6,268.628,155.6Z",
    transform: "translate(-225.132 -138.224)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.257 17.497)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M260.938,179.808v1.265a.965.965,0,0,0,.069.357.95.95,0,0,0,1.131.521l.977-.258",
    transform: "translate(-251.359 -170.314)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M266.144,165.859l8.356,1.978s-.38-2.148-3.8-2.928S266.144,165.859,266.144,165.859Z",
    transform: "translate(-253.293 -164.707)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M254.166,165.859l-8.464,1.978s.385-2.148,3.847-2.928S254.166,165.859,254.166,165.859Z",
    transform: "translate(-245.702 -164.707)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M252.787,174.017a1.316,1.316,0,1,1-1.316-1.309A1.312,1.312,0,0,1,252.787,174.017Z",
    transform: "translate(-247.355 -167.678)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M272.639,174.017a1.316,1.316,0,1,1-1.316-1.309A1.312,1.312,0,0,1,272.639,174.017Z",
    transform: "translate(-254.727 -167.678)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M252.959,186.7h11.554s-.815,3.175-6.055,3.175A6.128,6.128,0,0,1,252.959,186.7Z",
    transform: "translate(-248.397 -172.873)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M239.013,162.534s6.28-8.49,4.831-17.091a12.376,12.376,0,0,0-5.875,8.4C236.755,159.9,239.013,162.534,239.013,162.534Z",
    transform: "translate(-224.44 -140.057)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M282.3,161.91s-7.3-8.785-5.847-17.385a14.364,14.364,0,0,1,6.274,8.978C283.94,159.557,282.3,161.91,282.3,161.91Z",
    transform: "translate(-238.793 -139.716)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M240.679,146.629s7.206,9.685,29.268,8.174c0,0-2.52-13.812-13.212-15.191C256.735,139.612,244.389,138.138,240.679,146.629Z",
    transform: "translate(-225.58 -137.856)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 50.986)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 28.275)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M205.124,343.02c-.321.5,18.362-81.291,12.816-80.055-.506.113-10.221,1.015-11.664,3.951-4.186,8.51-7.188,75.484-7.188,75.484Z",
    transform: "translate(-198.727 -262.952)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M198.874,388.323s-3.011,13.972,8.373,15.5a1.6,1.6,0,0,0,1.722-1.057l.033-.095a1.6,1.6,0,0,0-.886-1.977c-1.856-.83-4.735-2.927-3.306-7.689,0,0,1.645-.2,2.554,2.868a1.32,1.32,0,0,0,1.855.815h0a1.32,1.32,0,0,0,.714-1.35c-.273-2.15-1.355-7.325-5.5-8.714Z",
    transform: "translate(-198.514 -308.874)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M205.181,293.388S215.946,308.548,216,308.255s3.765-21.284,3.765-21.284L206.7,281.312Z",
    transform: "translate(-200.989 -269.769)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.551)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M234.122,222.465c.46,0-26.6.482-31.55,34.655l15.553,2.383,3.136,25.8H264.65l8.614-47.666s-6.124-10.327-23.973-15.387Z",
    transform: "translate(-202.572 -219.563)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M231.716,225.01s3.825,5.077,19.5,5.077c15.525,0,19.5-5.343,19.5-5.343a66.939,66.939,0,0,0-19.773-6.768A70.355,70.355,0,0,0,231.716,225.01Z",
    transform: "translate(-213.394 -217.976)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.918 186.034)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M316.414,401.367l.037,68.152h33.715l2.591-68.152Z",
    transform: "translate(-316.414 -401.367)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M411.39,401.367l-.037,68.152H377.637l-2.591-68.152Z",
    transform: "translate(-338.186 -401.367)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "y",
    width: 34.86,
    height: 23.677,
    transform: "translate(19.931)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "z",
    x2: 24.044,
    transform: "translate(24.8 23.677)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 64.063)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(143.286 9.326)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.509 53.17)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M453.371,306.763c2.09,23.094-.114,39.92.5,82.415l-20.123.842-3-79.542Z",
    transform: "translate(-430.745 -306.763)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M434.689,328.514s12.462-1.141,20.981-6.761l-.224-4.946-20.764,2.828Z",
    transform: "translate(-432.207 -310.493)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M402.894,222.188s39.581,9.954,46.753,60.195c0,0-19.372,8.4-38.786,4.786l4.367-16.8Z",
    transform: "translate(-402.894 -222.188)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M207.738,255.417l29.471,34.8-9.018,25.4s-22.4-31.143-32.465-55.214Z",
    transform: "translate(-182.682 -225.201)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M203.745,245.3s-10.349,5.847-12.981,3.732c-4.6-3.7-8.4-17.225-8.4-17.225s19.352-7.3,19.17-7.011S203.745,245.3,203.745,245.3Z",
    transform: "translate(-177.72 -213.827)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M214.3,246.259c-.183-1.042,3.837-12.281,5.216-16.5a1.859,1.859,0,0,0-1.472-2.342h0a2.147,2.147,0,0,0-2.394.981l-4.854,8.3Z",
    transform: "translate(-188.28 -214.787)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M211.538,227.3l-3.333-16.581a2.087,2.087,0,0,0-2.412-1.655h0a1.8,1.8,0,0,0-1.476,1.994L205.77,223.4Z",
    transform: "translate(-185.867 -207.976)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M200.35,220.561l-4.526-11.84a2.077,2.077,0,0,0-2.571-1.266h0a1.79,1.79,0,0,0-1.183,2.124l3.358,13.681Z",
    transform: "translate(-181.306 -207.354)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M191.732,226.281l-5.726-11.634a2.276,2.276,0,0,0-2.906-1.115h0a1.983,1.983,0,0,0-1.023,2.619l4.565,10.983Z",
    transform: "translate(-177.553 -209.584)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M179.621,230.382l-4.493-7.127a1.609,1.609,0,0,1,.785-2.15h0a1.839,1.839,0,0,1,2.246.653l5.908,8.2Z",
    transform: "translate(-174.978 -212.403)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M209.975,236.1s-6.748-.708-7.441,8.285",
    transform: "translate(-185.21 -218.023)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.532 8.455)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 20.293)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M237.859,302.873s5.543,19.183,16.588,16.632,28.261-26.142,28.261-26.142l-3.853-40.282-31,38.156Z",
    transform: "translate(-237.859 -253.082)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M269.051,292.877s10.467,15.788,19.4,21.355l5.844-7.377-22.545-17.44Z",
    transform: "translate(-249.441 -266.573)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M314.071,220.8s-30.73,6.926-47.106,42.641c0,0,9.894,14.908,25.756,21.535l10.62-13.01Z",
    transform: "translate(-248.667 -220.803)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(84.913 5.676)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M330.346,219.051A76.958,76.958,0,0,0,310.8,233.374l2.368,104.4H388.81l-.245-103.859s-9.535-9.331-19.869-13.881C359.918,216.169,338.879,214.674,330.346,219.051Z",
    transform: "translate(-310.323 -216.383)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M0,0H21.044a0,0,0,0,1,0,0V10.522A10.522,10.522,0,0,1,10.522,21.044h0A10.522,10.522,0,0,1,0,10.522V0A0,0,0,0,1,0,0Z",
    transform: "translate(45.296 32.495)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "z",
    y1: 34.152,
    x2: 0.981,
    transform: "translate(78.364 34.866)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "z",
    x1: 1.634,
    y1: 29.604,
    transform: "translate(0 33.722)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(98.966)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M341.229,143.684l-3.153-15.6c-.177-1.271-.67-3.231-.067-5.074,1-3.048,4.67-8.9,10.943-6.222l1.357,6.176s-6.516,1.315-9.13,9.839Z",
    transform: "translate(-334.373 -109.408)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M349.306,122.313c-.114,2.049-1.923,11.018-8.284,14.286C341.022,136.6,335.451,124.65,349.306,122.313Z",
    transform: "translate(-335.189 -111.714)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M371.629,200.412h0V173.921h-24.42v26.491l-7.269,3.314s1.7,10.979,19.736,11.223,19.842-10.682,19.842-10.682Z",
    transform: "translate(-335.198 -130.877)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M355.588,112.833s4.482-11.824,18.3-5.538c8.365,3.8,10.708,8.905,11.7,12.519a14.54,14.54,0,0,1,.373,4.216l-3.343,15.7-13.051-21.722-12.629,1Z",
    transform: "translate(-341.008 -105.453)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(40.167 32.589)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M397.738,158.978a4.067,4.067,0,0,1,5.042-1.331c3.4,1.288,1.86,9.535-3.234,10.586a4.029,4.029,0,0,1-3.258-.852S397.54,161.289,397.738,158.978Z",
    transform: "translate(-396.288 -157.291)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.955 3.173)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M402.67,162.43s-2.845-.949-4.863,3.24",
    transform: "translate(-397.807 -162.338)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 32.589)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M339.253,158.978a4.067,4.067,0,0,0-5.042-1.331c-3.4,1.288-1.86,9.535,3.234,10.586a4.029,4.029,0,0,0,3.258-.852S339.45,161.289,339.253,158.978Z",
    transform: "translate(-332.397 -157.291)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.488 3.173)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M336.354,162.43s2.845-.949,4.863,3.24",
    transform: "translate(-336.354 -162.338)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M378.172,137.091c0,4.972-.487,15.372-3.543,21.546-2.87,5.8-7.616,8.916-13.838,9.1s-10.857-2.212-14.572-9.735-3.538-20.82-3.538-20.82,0-17.76,17.553-17.76C378.721,119.424,378.172,137.091,378.172,137.091Z",
    transform: "translate(-336.215 -110.641)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M351.794,186.688s2.045,10.376,11.075,11.568c10.393,1.372,13.161-11.3,13.161-11.3s-4.593,5.755-11.856,5.764A15.891,15.891,0,0,1,351.794,186.688Z",
    transform: "translate(-339.6 -135.618)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.681 22.294)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M368.917,159.254v4.11a1.344,1.344,0,0,0,.1.5,1.323,1.323,0,0,0,1.577.732l1.363-.363",
    transform: "translate(-352.639 -147.725)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M358.784,155.188a1.6,1.6,0,1,1-1.6-1.6A1.6,1.6,0,0,1,358.784,155.188Z",
    transform: "translate(-347.689 -145.622)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M382.614,155.188a1.6,1.6,0,1,1-1.6-1.6A1.6,1.6,0,0,1,382.614,155.188Z",
    transform: "translate(-356.538 -145.622)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M375.454,142.533l10.743,2.775s-.488-3.013-4.884-4.108S375.454,142.533,375.454,142.533Z",
    transform: "translate(-355.066 -140.916)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M358.489,142.533l-10.743,2.775s.488-3.013,4.884-4.108S358.489,142.533,358.489,142.533Z",
    transform: "translate(-344.778 -140.916)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M361.436,172.379s1.585,1.215,5.753,1.215a14.568,14.568,0,0,0,6.157-1.215",
    transform: "translate(-349.861 -152.599)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 3.243)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "ab",
    cx: 6.79,
    cy: 6.79,
    r: 6.79,
    transform: "translate(2.277)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "ab",
    cx: 6.79,
    cy: 6.79,
    r: 6.79,
    transform: "translate(18.957)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M368.246,156.481a2.21,2.21,0,0,1,3.1,0",
    transform: "translate(-352.39 -149.691)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ab",
    x1: 2.277,
    y1: 0.058,
    transform: "translate(0 6.732)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ab",
    y1: 0.041,
    x2: 2.542,
    transform: "translate(32.537 6.749)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M351.794,120.632s3.261,9.264,17.975,8.979c10-.193,12.387,7.042,12.387,7.042s-1.74-16.174-2.2-16.021-15.214-3.937-15.214-3.937Z",
    transform: "translate(-339.6 -109.628)"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(187.726 44.805)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "ac",
    cx: 0.808,
    cy: 0.808,
    r: 0.808,
    transform: "translate(5.658 16.165)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "ac",
    cx: 0.808,
    cy: 0.808,
    r: 0.808,
    transform: "translate(16.973 16.165)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M262.052,50.417h3.233l2.425,13.74h12.932",
    transform: "translate(-262.052 -50.417)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M270.1,62.357h12.6a.4.4,0,0,0,.4-.325l1.455-7.274a.4.4,0,0,0-.317-.475.373.373,0,0,0-.079-.008H268.48",
    transform: "translate(-264.439 -51.849)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDify);
export default __webpack_public_path__ + "static/media/Dify.92c76b544bf230413e7cbda71eb13f09.svg";
export { ForwardRef as ReactComponent };